import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var FormStatusCheck = /*#__PURE__*/function (_Entity) {
  _inherits(FormStatusCheck, _Entity);

  var _super = _createSuper(FormStatusCheck);

  function FormStatusCheck() {
    _classCallCheck(this, FormStatusCheck);

    return _super.apply(this, arguments);
  }

  _createClass(FormStatusCheck, [{
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var id = data.id,
            title = data.title,
            status = data.status;
        return this.create({
          id: id,
          title: title,
          status: status
        });
      } catch (error) {
        return Result.fail(error);
      }
    }
  }, {
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.title,
        argumentName: 'Title'
      }, {
        argument: props.status,
        argumentName: 'Status'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new FormStatusCheck(props, new UniqueEntityID(props.id.toString())));
    }
  }]);

  return FormStatusCheck;
}(Entity);